const resource = 'languages'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },
  get(id, params) {
    return $axios.$get(`/${resource}/${id}`, { params })
  },

  getServiceName: name => 'languageService',
})
